/* eslint-disable no-mixed-operators */
import React, { useEffect, useState } from "react";
import { useMutation, useQuery } from "@apollo/client";
import { CREATE_HALF_YEAR } from "../graphql/mutations";
import {
  INTROLES,
  VACROLES,
  NHCROLES,
  DAF1ROLES,
  DAF2ROLES,
  DAF3ROLES,
  BED1ROLES,
  BED2ROLES,
  // BED3ROLES,
  // BED4ROLES,
  // BED5ROLES,
  LNKRROLES,
  LNKNROLES,
  LNKIROLES,
  IEVRROLES,
  IEVNROLES,
  IEVIROLES,
  IEVCROLES,
  NTWUROLES,
  CONROLES,
  // ISCROLES,
  // EXPROLES,
  // STFROLES,
  STSROLES,
  FSCROLES,
  VC3ROLES,
  VC5ROLES,
  VC6ROLES,
  VC8ROLES,
  MMEROLES,
  RVNROLES,
  RVN1ROLES,
  BSTCROLES,
  BSTFROLES,
  WNFROLES,
  DOEROLES,
  DSEROLES,
  NRIROLES,
} from "../graphql/queries";
import CustomSelect from "./CustomSelect";
import CustomMultiselectForm from "./CustomMultiselectForm";
import { Link } from "react-router-dom";

// eslint-disable-next-line no-unused-vars
const axios = require("axios");

function StartupdatahalfJear(props) {
  const confirmationCode = props.match.params.code;
  const startupId = props.match.params.startupId;

  const [valid, setValid] = useState(false);
  const [done, setDone] = useState(false);

  // ????

useEffect(() => {
  const confirmationUrl =
    process.env.REACT_APP_MAIL_CONFIRMATION_PROFILE_CONFIRMATION_URL ||
    "https://f1j07exi8h.execute-api.eu-central-1.amazonaws.com/dev/profile-confirmation";
  fetch(`${confirmationUrl}?code=${confirmationCode}&startupid=${startupId}`)
    .then(response => {
      setValid(response.status === 200);
      setDone(true);
    })
    .catch((_) => setDone(true));
}, [confirmationCode, startupId]);
  // Fetch RMOROLES
  const [emp, setName] = useState("");

  // Fetch INTROLES
  const [intranges, setIntranges] = useState();
  const intrangesQuery = useQuery(INTROLES);
  useEffect(() => {
    if (intrangesQuery?.data) {
      const dataReceived = intrangesQuery?.data.intRanges?.data.map(
        (intranges) => ({
          value: intranges.id,
          label: intranges.attributes.value,
        })
      );

      setIntranges(dataReceived);
    }
  }, [intrangesQuery?.data, intrangesQuery.error]);

  // Fetch VACROLES
  const [vacranges, setVacranges] = useState();
  const vacrangesQuery = useQuery(VACROLES);
  useEffect(() => {
    if (vacrangesQuery?.data) {
      const dataReceived = vacrangesQuery?.data.vacRanges?.data.map(
        (vacranges) => ({
          value: vacranges.id,
          label: vacranges.attributes.value,
        })
      );

      setVacranges(dataReceived);
    }
  }, [vacrangesQuery?.data, vacrangesQuery.error]);

  // Fetch vac1
  const [vac1, setVac1] = useState("");

  // Fetch NHCROLES
  const [nhcranges, setNhcranges] = useState();
  const nhcrangesQuery = useQuery(NHCROLES);
  useEffect(() => {
    if (nhcrangesQuery?.data) {
      const dataReceived = nhcrangesQuery?.data.nhcRanges?.data.map(
        (nhcranges) => ({
          value: nhcranges.id,
          label: nhcranges.attributes.value,
        })
      );

      setNhcranges(dataReceived);
    }
  }, [nhcrangesQuery?.data, nhcrangesQuery.error]);

  // Fetch BTW
  const [btw, setBtw] = useState(0);

  // Fetch CUSB
  const [cusb, setCusb] = useState("");

  // Fetch CUSER
  const [cuse, setCuse] = useState("");

  // Fetch CUSN
  const [cusn, setCusn] = useState("");

  // Fetch DAF1ROLES
  const [daf1ranges, setDaf1ranges] = useState();
  const daf1rangesQuery = useQuery(DAF1ROLES);
  useEffect(() => {
    if (daf1rangesQuery?.data) {
      const dataReceived = daf1rangesQuery?.data.daf1Ranges?.data.map(
        (daf1ranges) => ({
          value: daf1ranges.id,
          label: daf1ranges.attributes.value,
        })
      );

      setDaf1ranges(dataReceived);
    }
  }, [daf1rangesQuery?.data, daf1rangesQuery.error]);

  // Fetch DAF2ROLES
  const [daf2ranges, setDaf2ranges] = useState();
  const daf2rangesQuery = useQuery(DAF2ROLES);
  useEffect(() => {
    if (daf2rangesQuery?.data) {
      const dataReceived = daf2rangesQuery?.data.daf2Ranges?.data.map(
        (daf2ranges) => ({
          value: daf2ranges.id,
          label: daf2ranges.attributes.value,
        })
      );

      setDaf2ranges(dataReceived);
    }
  }, [daf2rangesQuery?.data, daf2rangesQuery.error]);

  // Fetch DAF3ROLES
  const [daf3ranges, setDaf3ranges] = useState();
  const daf3rangesQuery = useQuery(DAF3ROLES);
  useEffect(() => {
    if (daf3rangesQuery?.data) {
      const dataReceived = daf3rangesQuery?.data.daf3Ranges?.data.map(
        (daf3ranges) => ({
          value: daf3ranges.id,
          label: daf3ranges.attributes.value,
        })
      );

      setDaf3ranges(dataReceived);
    }
  }, [daf3rangesQuery?.data, daf3rangesQuery.error]);

  // Fetch BED1ROLES
  const [bed1ranges, setBed1ranges] = useState();
  const bed1rangesQuery = useQuery(BED1ROLES);
  useEffect(() => {
    if (bed1rangesQuery?.data) {
      const dataReceived = bed1rangesQuery?.data.bed1Ranges?.data.map(
        (bed1ranges) => ({
          value: bed1ranges.id,
          label: bed1ranges.attributes.value,
        })
      );

      setBed1ranges(dataReceived);
    }
  }, [bed1rangesQuery?.data, bed1rangesQuery.error]);

  // Fetch BED2ROLES
  const [bed2ranges, setBed2ranges] = useState();
  const bed2rangesQuery = useQuery(BED2ROLES);
  useEffect(() => {
    if (bed2rangesQuery?.data) {
      const dataReceived = bed2rangesQuery?.data.bed2Ranges?.data.map(
        (bed2ranges) => ({
          value: bed2ranges.id,
          label: bed2ranges.attributes.value,
        })
      );

      setBed2ranges(dataReceived);
    }
  }, [bed2rangesQuery?.data, bed2rangesQuery.error]);
  /*
  // Fetch BED3ROLES
  const [bed3ranges, setBed3ranges] = useState();
  const bed3rangesQuery = useQuery(BED3ROLES);
  useEffect(() => {
    if (bed3rangesQuery?.data) {
      const dataReceived = bed3rangesQuery?.data.bed3Ranges?.data.map(bed3ranges => ({
        value: bed3ranges.id,
        label: bed3ranges.attributes.value,
      }));

      setBed3ranges(dataReceived);
    }
  }, [bed3rangesQuery?.data, bed3rangesQuery.error]);

  // Fetch BED4ROLES
  const [bed4ranges, setBed4ranges] = useState();
  const bed4rangesQuery = useQuery(BED4ROLES);
  useEffect(() => {
    if (bed4rangesQuery?.data) {
      const dataReceived = bed4rangesQuery?.data.bed4Ranges?.data.map(bed4ranges => ({
        value: bed4ranges.id,
        label: bed4ranges.attributes.value,
      }));

      setBed4ranges(dataReceived);
    }
  }, [bed4rangesQuery?.data, bed4rangesQuery.error]);

  // Fetch BED5ROLES
  const [bed5ranges, setBed5ranges] = useState();
  const bed5rangesQuery = useQuery(BED5ROLES);
  useEffect(() => {
    if (bed5rangesQuery?.data) {
      const dataReceived = bed5rangesQuery?.data.bed5Ranges?.data.map(bed5ranges => ({
        value: bed5ranges.id,
        label: bed5ranges.attributes.value,
      }));

      setBed5ranges(dataReceived);
    }
  }, [bed5rangesQuery?.data, bed5rangesQuery.error]);
*/
  // Fetch LNKRROLES
  const [lnkRranges, setLnkRranges] = useState();
  const lnkRrangesQuery = useQuery(LNKRROLES);
  useEffect(() => {
    if (lnkRrangesQuery?.data) {
      const dataReceived = lnkRrangesQuery?.data.lnkRRanges?.data.map(
        (lnkRranges) => ({
          value: lnkRranges.id,
          label: lnkRranges.attributes.value,
        })
      );

      setLnkRranges(dataReceived);
    }
  }, [lnkRrangesQuery?.data, lnkRrangesQuery.error]);

  // Fetch LNKNROLES
  const [lnkNranges, setLnkNranges] = useState();
  const lnkNrangesQuery = useQuery(LNKNROLES);
  useEffect(() => {
    if (lnkNrangesQuery?.data) {
      const dataReceived = lnkNrangesQuery?.data.lnkNRanges?.data.map(
        (lnkNranges) => ({
          value: lnkNranges.id,
          label: lnkNranges.attributes.value,
        })
      );

      setLnkNranges(dataReceived);
    }
  }, [lnkNrangesQuery?.data, lnkNrangesQuery.error]);

  // Fetch LNKIROLES
  const [lnkIranges, setLnkIranges] = useState();
  const lnkIrangesQuery = useQuery(LNKIROLES);
  useEffect(() => {
    if (lnkIrangesQuery?.data) {
      const dataReceived = lnkIrangesQuery?.data.lnkIRanges?.data.map(
        (lnkIranges) => ({
          value: lnkIranges.id,
          label: lnkIranges.attributes.value,
        })
      );

      setLnkIranges(dataReceived);
    }
  }, [lnkIrangesQuery?.data, lnkIrangesQuery.error]);

  // Fetch IEVRROLES
  const [ievRranges, setIevRranges] = useState();
  const ievRrangesQuery = useQuery(IEVRROLES);
  useEffect(() => {
    if (ievRrangesQuery?.data) {
      const dataReceived = ievRrangesQuery?.data.ievRRanges?.data.map(
        (ievRranges) => ({
          value: ievRranges.id,
          label: ievRranges.attributes.value,
        })
      );

      setIevRranges(dataReceived);
    }
  }, [ievRrangesQuery?.data, ievRrangesQuery.error]);

  // Fetch IEVNROLES
  const [ievNranges, setIevNranges] = useState();
  const ievNrangesQuery = useQuery(IEVNROLES);
  useEffect(() => {
    if (ievNrangesQuery?.data) {
      const dataReceived = ievNrangesQuery?.data.ievNRanges?.data.map(
        (ievNranges) => ({
          value: ievNranges.id,
          label: ievNranges.attributes.value,
        })
      );

      setIevNranges(dataReceived);
    }
  }, [ievNrangesQuery?.data, ievNrangesQuery.error]);

  // Fetch IEVIROLES
  const [ievIranges, setIevIranges] = useState();
  const ievIrangesQuery = useQuery(IEVIROLES);
  useEffect(() => {
    if (ievIrangesQuery?.data) {
      const dataReceived = ievIrangesQuery?.data.ievIRanges?.data.map(
        (ievIranges) => ({
          value: ievIranges.id,
          label: ievIranges.attributes.value,
        })
      );

      setIevIranges(dataReceived);
    }
  }, [ievIrangesQuery?.data, ievIrangesQuery.error]);

  // Fetch IEVCROLES
  const [ievCranges, setIevCranges] = useState();
  const ievCrangesQuery = useQuery(IEVCROLES);
  useEffect(() => {
    if (ievCrangesQuery?.data) {
      const dataReceived = ievCrangesQuery?.data.ievCRanges?.data.map(
        (ievCranges) => ({
          value: ievCranges.id,
          label: ievCranges.attributes.value,
        })
      );

      setIevCranges(dataReceived);
    }
  }, [ievCrangesQuery?.data, ievCrangesQuery.error]);

  // Fetch NTWUROLES
  const [ntwUranges, setntwUranges] = useState();
  const ntwUrangesQuery = useQuery(NTWUROLES);
  useEffect(() => {
    if (ntwUrangesQuery?.data) {
      const dataReceived = ntwUrangesQuery?.data.ntwURanges?.data.map(
        (ntwUranges) => ({
          value: ntwUranges.id,
          label: ntwUranges.attributes.value,
        })
      );

      setntwUranges(dataReceived);
    }
  }, [ntwUrangesQuery?.data, ntwUrangesQuery.error]);

  // Fetch CONROLES
  const [conranges, setconranges] = useState();
  const conrangesQuery = useQuery(CONROLES);
  useEffect(() => {
    if (conrangesQuery?.data) {
      const dataReceived = conrangesQuery?.data.conRanges?.data.map(
        (conranges) => ({
          value: conranges.id,
          label: conranges.attributes.value,
        })
      );

      setconranges(dataReceived);
    }
  }, [conrangesQuery?.data, conrangesQuery.error]);
  /*
  // Fetch ISCROLES
  const [iscranges, setiscranges] = useState();
  const iscrangesQuery = useQuery(ISCROLES);
  useEffect(() => {
    if (iscrangesQuery?.data) {
      const dataReceived = iscrangesQuery?.data.iscRanges?.data.map(
        (iscranges) => ({
          value: iscranges.id,
          label: iscranges.attributes.value,
        })
      );

      setiscranges(dataReceived);
    }
  }, [iscrangesQuery?.data, iscrangesQuery.error]);

  // Fetch EXPROLES
  const [expranges, setexpranges] = useState();
  const exprangesQuery = useQuery(EXPROLES);
  useEffect(() => {
    if (exprangesQuery?.data) {
      const dataReceived = exprangesQuery?.data.expRanges?.data.map(
        (expranges) => ({
          value: expranges.id,
          label: expranges.attributes.value,
        })
      );

      setexpranges(dataReceived);
    }
  }, [exprangesQuery?.data, exprangesQuery.error]);

  // Fetch STFROLES
  const [stFranges, setstFranges] = useState();
  const stFrangesQuery = useQuery(STFROLES);
  useEffect(() => {
    if (stFrangesQuery?.data) {
      const dataReceived = stFrangesQuery?.data.stFRanges?.data.map(
        (stFranges) => ({
          value: stFranges.id,
          label: stFranges.attributes.value,
        })
      );

      setstFranges(dataReceived);
    }
  }, [stFrangesQuery?.data, stFrangesQuery.error]);
*/
  // Fetch STSROLES
  const [stSranges, setstSranges] = useState();
  const stSrangesQuery = useQuery(STSROLES);
  useEffect(() => {
    if (stSrangesQuery?.data) {
      const dataReceived = stSrangesQuery?.data.stSRanges?.data.map(
        (stSranges) => ({
          value: stSranges.id,
          label: stSranges.attributes.value,
        })
      );

      setstSranges(dataReceived);
    }
  }, [stSrangesQuery?.data, stSrangesQuery.error]);

  // Fetch FSCROLES
  const [fscranges, setfscranges] = useState();
  const fscrangesQuery = useQuery(FSCROLES);
  useEffect(() => {
    if (fscrangesQuery?.data) {
      const dataReceived = fscrangesQuery?.data.fscRanges?.data.map(
        (fscranges) => ({
          value: fscranges.id,
          label: fscranges.attributes.value,
        })
      );

      setfscranges(dataReceived);
    }
  }, [fscrangesQuery?.data, fscrangesQuery.error]);

  // Fetch VC3ROLES
  const [vc3ranges, setvc3ranges] = useState();
  const vc3rangesQuery = useQuery(VC3ROLES);
  useEffect(() => {
    if (vc3rangesQuery?.data) {
      const dataReceived = vc3rangesQuery?.data.vc3Ranges?.data.map(
        (vc3ranges) => ({
          value: vc3ranges.id,
          label: vc3ranges.attributes.value,
        })
      );

      setvc3ranges(dataReceived);
    }
  }, [vc3rangesQuery?.data, vc3rangesQuery.error]);

  // Fetch VC5ROLES
  const [vc5ranges, setvc5ranges] = useState();
  const vc5rangesQuery = useQuery(VC5ROLES);
  useEffect(() => {
    if (vc5rangesQuery?.data) {
      const dataReceived = vc5rangesQuery?.data.vc5Ranges?.data.map(
        (vc5ranges) => ({
          value: vc5ranges.id,
          label: vc5ranges.attributes.value,
        })
      );

      setvc5ranges(dataReceived);
    }
  }, [vc5rangesQuery?.data, vc5rangesQuery.error]);

  // Fetch VC6ROLES
  const [vc6ranges, setvc6ranges] = useState();
  const vc6rangesQuery = useQuery(VC6ROLES);
  useEffect(() => {
    if (vc6rangesQuery?.data) {
      const dataReceived = vc6rangesQuery?.data.vc6Ranges?.data.map(
        (vc6ranges) => ({
          value: vc6ranges.id,
          label: vc6ranges.attributes.value,
        })
      );

      setvc6ranges(dataReceived);
    }
  }, [vc6rangesQuery?.data, vc6rangesQuery.error]);

  // Fetch VC8ROLES
  const [vc8ranges, setvc8ranges] = useState();
  const vc8rangesQuery = useQuery(VC8ROLES);

  useEffect(() => {
    if (vc8rangesQuery?.data) {
      const dataReceived = vc8rangesQuery?.data.vc8Ranges?.data.map(
        (vc8ranges) => ({
          value: vc8ranges.id,
          label: vc8ranges.attributes.value,
        })
      );

      setvc8ranges(dataReceived);
    }
  }, [vc8rangesQuery?.data, vc8rangesQuery.error]);

  // Fetch WNFROLES
  const [wnfranges, setWnfRanges] = useState();
  const wnfRangesQuery = useQuery(WNFROLES);

  useEffect(() => {
    if (wnfRangesQuery?.data) {
      const dataReceived = wnfRangesQuery?.data.wnfRanges?.data.map(
        (wnfranges) => ({
          value: wnfranges.id,
          label: wnfranges.attributes.value,
        })
      );

      setWnfRanges(dataReceived);
    }
  }, [wnfRangesQuery?.data, wnfRangesQuery.error]);

  // Fetch DOEROLES
  const [doeranges, setDoeRanges] = useState();
  const doeRangesQuery = useQuery(DOEROLES);

  useEffect(() => {
    if (doeRangesQuery?.data) {
      const dataReceived = doeRangesQuery?.data.doeRanges?.data.map(
        (doeranges) => ({
          value: doeranges.id,
          label: doeranges.attributes.value,
        })
      );

      setDoeRanges(dataReceived);
    }
  }, [doeRangesQuery?.data, doeRangesQuery.error]);

  // Fetch DSEROLES
  const [dseranges, setDseRanges] = useState();
  const dseRangesQuery = useQuery(DSEROLES);

  useEffect(() => {
    if (dseRangesQuery?.data) {
      const dataReceived = dseRangesQuery?.data.dseRanges?.data.map(
        (dseranges) => ({
          value: dseranges.id,
          label: dseranges.attributes.value,
        })
      );

      setDseRanges(dataReceived);
    }
  }, [dseRangesQuery?.data, dseRangesQuery.error]);

  // Fetch NRIROLES
  const [nriranges, setNriRanges] = useState();
  const nriRangesQuery = useQuery(NRIROLES);

  useEffect(() => {
    if (nriRangesQuery?.data) {
      const dataReceived = nriRangesQuery?.data.nriRanges?.data.map(
        (nriranges) => ({
          value: nriranges.id,
          label: nriranges.attributes.value,
        })
      );

      setNriRanges(dataReceived);
    }
  }, [nriRangesQuery?.data, nriRangesQuery.error]);

  // Fetch MMEROLES
  const [mmeranges, setmmeranges] = useState();
  const mmerangesQuery = useQuery(MMEROLES);
  useEffect(() => {
    if (mmerangesQuery?.data) {
      const dataReceived = mmerangesQuery?.data.mmeRanges?.data.map(
        (mmeranges) => ({
          value: mmeranges.id,
          label: mmeranges.attributes.value,
        })
      );

      setmmeranges(dataReceived);
    }
  }, [mmerangesQuery?.data, mmerangesQuery.error]);

  // Fetch RVNROLES
  const [rvnranges, setRvnranges] = useState();
  const rvnrangesQuery = useQuery(RVNROLES);
  useEffect(() => {
    if (rvnrangesQuery?.data) {
      const dataReceived = rvnrangesQuery?.data.rvnRanges?.data.map(
        (rvnranges) => ({
          value: rvnranges.id,
          label: rvnranges.attributes.value,
        })
      );

      setRvnranges(dataReceived);
    }
  }, [rvnrangesQuery?.data, rvnrangesQuery.error]);

  // Fetch RVN1ROLES
  const [rvn1ranges, setRvn1ranges] = useState();
  const rvn1rangesQuery = useQuery(RVN1ROLES);
  useEffect(() => {
    if (rvn1rangesQuery?.data) {
      const dataReceived = rvn1rangesQuery?.data.rvn1Ranges?.data.map(
        (rvn1ranges) => ({
          value: rvn1ranges.id,
          label: rvn1ranges.attributes.value,
        })
      );

      setRvn1ranges(dataReceived);
    }
  }, [rvn1rangesQuery?.data, rvn1rangesQuery.error]);

  // Fetch BSTCROLES
  const [bstCranges, setBstCranges] = useState();
  const bstCrangesQuery = useQuery(BSTCROLES);
  useEffect(() => {
    if (bstCrangesQuery?.data) {
      const dataReceived = bstCrangesQuery?.data.bstCRanges?.data.map(
        (bstCranges) => ({
          value: bstCranges.id,
          label: bstCranges.attributes.value,
        })
      );

      setBstCranges(dataReceived);
    }
  }, [bstCrangesQuery?.data, bstCrangesQuery.error]);

  // Fetch BSTFROLES
  const [bstFranges, setBstFranges] = useState();
  const bstFrangesQuery = useQuery(BSTFROLES);
  useEffect(() => {
    if (bstFrangesQuery?.data) {
      const dataReceived = bstFrangesQuery?.data.bstFRanges?.data.map(
        (bstFranges) => ({
          value: bstFranges.id,
          label: bstFranges.attributes.value,
        })
      );

      setBstFranges(dataReceived);
    }
  }, [bstFrangesQuery?.data, bstFrangesQuery.error]);

  /* intrange */
  const [intrange, setIntrange] = useState("");
  const [intrangeError, setIntrangeError] = useState("");
  function handleChangeintrange(selectedOption) {
    setIntrange(selectedOption.value);
    setIntrangeError("");
  }

  /* vacrange */
  const [vacrange, setVacrange] = useState("");
  const [vacrangeError, setVacrangeError] = useState("");
  function handleChangevacrange(selectedOption) {
    setVacrange(selectedOption.value);
    setVacrangeError("");
  }

  /* nhcrange */
  const [nhcrange, setNhcrange] = useState("");
  const [nhcrangeError, setNhcrangeError] = useState("");
  function handleChangenhcrange(selectedOption) {
    setNhcrange(selectedOption.value);
    setNhcrangeError("");
  }

  /* daf1range */
  const [daf1range, setDaf1range] = useState("");
  const [daf1rangeError, setDaf1rangeError] = useState("");
  function handleChangedaf1range(selectedOption) {
    setDaf1range(selectedOption.value);
    setDaf1rangeError("");
  }

  /* daf2range */
  const [daf2range, setDaf2range] = useState("");
  const [daf2rangeError, setDaf2rangeError] = useState("");
  function handleChangedaf2range(selectedOption) {
    setDaf2range(selectedOption.value);
    setDaf2rangeError("");
  }

  /* daf3range */
  const [daf3range, setDaf3range] = useState("");
  const [daf3rangeError, setDaf3rangeError] = useState("");
  function handleChangedaf3range(selectedOption) {
    setDaf3range(selectedOption.value);
    setDaf3rangeError("");
  }

  /*bed1range*/
  const [bed1range, setBed1range] = useState("");
  const [bed1rangeError, setBed1rangeError] = useState("");
  function handleChangeBed1range(selectedOption) {
    setBed1range(selectedOption.value);
    setBed1rangeError("");
  }

  /*bed2range*/
  const [bed2range, setBed2range] = useState("");
  const [bed2rangeError, setBed2rangeError] = useState("");
  function handleChangeBed2range(selectedOption) {
    setBed2range(selectedOption.value);
    setBed2rangeError("");
  }
  /*
  //bed3range
  const [bed3range, setBed3range] = useState("");
  const [bed3rangeError, setBed3rangeError] = useState("");
  function handleChangeBed3range(selectedOption) {
    setBed3range(selectedOption.value);
    setBed3rangeError("");
  }

  //bed4range
  const [bed4range, setBed4range] = useState("");
  const [bed4rangeError, setBed4rangeError] = useState("");
  function handleChangeBed4range(selectedOption) {
    setBed4range(selectedOption.value);
    setBed4rangeError("");
  }

  //bed5range
  const [bed5range, setBed5range] = useState("");
  const [bed5rangeError, setBed5rangeError] = useState("");
  function handleChangeBed5range(selectedOption) {
    setBed5range(selectedOption.value);
    setBed5rangeError("");
  }
*/
  /* lnkrrange */
  const [lnkRrange, setLnkRrange] = useState("");
  const [lnkRrangeError, setLnkRrangeError] = useState("");
  function handleChangelnkRrange(selectedOption) {
    setLnkRrange(selectedOption.value);
    setLnkRrangeError("");
  }

  /* lnknrange */
  const [lnkNrange, setLnkNrange] = useState("");
  const [lnkNrangeError, setLnkNrangeError] = useState("");
  function handleChangelnkNrange(selectedOption) {
    setLnkNrange(selectedOption.value);
    setLnkNrangeError("");
  }

  /* lnkirange */
  const [lnkIrange, setLnkIrange] = useState("");
  const [lnkIrangeError, setLnkIrangeError] = useState("");
  function handleChangelnkIrange(selectedOption) {
    setLnkIrange(selectedOption.value);
    setLnkIrangeError("");
  }

  /* ievrrange */
  const [ievRrange, setIevRrange] = useState("");
  const [ievRrangeError, setIevRrangeError] = useState("");
  function handleChangeievRrange(selectedOption) {
    setIevRrange(selectedOption.value);
    setIevRrangeError("");
  }

  /* ievnrange */
  const [ievNrange, setIevNrange] = useState("");
  const [ievNrangeError, setIevNrangeError] = useState("");
  function handleChangeievNrange(selectedOption) {
    setIevNrange(selectedOption.value);
    setIevNrangeError("");
  }

  /* ievirange */
  const [ievIrange, setIevIrange] = useState("");
  const [ievIrangeError, setIevIrangeError] = useState("");
  function handleChangeievIrange(selectedOption) {
    setIevIrange(selectedOption.value);
    setIevIrangeError("");
  }

  /* ievcrange */
  const [ievCrange, setIevCrange] = useState("");
  const [ievCrangeError, setIevCrangeError] = useState("");
  function handleChangeievCrange(selectedOption) {
    setIevCrange(selectedOption.value);
    setIevCrangeError("");
  }

  /* ntwUrange */
  const [ntwUrange, setNtwUrange] = useState([]);
  const [ntwUrangeError, setNtwUrangeError] = useState("");
  function handleChangentwUrange(selectedOption) {
    setNtwUrange(selectedOption);
    setNtwUrangeError("");
  }

  /* NtwUrangeother */
  const [textNtwUt, setTextNtwU] = useState("");

  // ntwM
  const [ntwM, setntwM] = useState("");

  /* conrange */
  const [conrange, setConrange] = useState("");
  const [conrangeError, setConrangeError] = useState("");
  function handleChangeconrange(selectedOption) {
    setConrange(selectedOption.value);
    setConrangeError("");
  }
  /*
  // iscrange 
  const [iscrange, setIscrange] = useState("");
  const [iscrangeError, setIscrangeError] = useState("");
  function handleChangeiscrange(selectedOption) {
    setIscrange(selectedOption.value);
    setIscrangeError("");
  }

  // exprange 
  const [exprange, setExprange] = useState("");
  const [exprangeError, setExprangeError] = useState("");
  function handleChangeexprange(selectedOption) {
    setExprange(selectedOption.value);
    setExprangeError("");
  }

  // stfrange 
  const [stFrange, setStFrange] = useState("");
  const [stFrangeError, setStFrangeError] = useState("");
  function handleChangestFrange(selectedOption) {
    setStFrange(selectedOption.value);
    setStFrangeError("");
  }
*/
  /* stsrange */
  const [stSrange, setStSrange] = useState([]);
  const [stSrangeError, setStSrangeError] = useState("");
  function handleChangestSrange(selectedOption) {
    setStSrange(selectedOption);
    setStSrangeError("");
  }

  /* fscrange */
  const [fscrange, setfscrange] = useState([]);
  const [fscrangeError, setfscrangeError] = useState("");
  function handleChangefscrange(selectedOption) {
    setfscrange(selectedOption);
    setfscrangeError("");
  }

  /* vc3range */
  const [vc3range, setvc3range] = useState("");
  const [vc3rangeError, setvc3rangeError] = useState("");
  function handleChangevc3range(selectedOption) {
    setvc3range(selectedOption.value);
    setvc3rangeError("");
  }

  /* vc5range */
  const [vc5range, setvc5range] = useState("");
  const [vc5rangeError, setvc5rangeError] = useState("");
  function handleChangevc5range(selectedOption) {
    setvc5range(selectedOption.value);
    setvc5rangeError("");
  }

  /* vc6range */
  const [vc6range, setvc6range] = useState("");
  function handleChangevc6range(selectedOption) {
    setvc6range(selectedOption.value);
  }

  /* vc8range */
  const [vc8range, setvc8range] = useState("");
  function handleChangevc8range(selectedOption) {
    setvc8range(selectedOption.value);
  }

  /* WNF range */
  const [wnfRange, setWnfRange] = useState("");
  const [wnfRangeError, setWnfRangeError] = useState("");
  function handleChangeWnfRange(selectedOption) {
    setWnfRange(selectedOption.value);
    setWnfRangeError("");
  }

  /* WNFrangeother */
  const [textWnf, settextWnf] = useState("");

  /* DOE range */
  const [doeRange, setDoeRange] = useState("");
  const [doeRangeError, setDoeRangeError] = useState("");
  function handleChangeDoeRange(selectedOption) {
    setDoeRange(selectedOption.value);
    setDoeRangeError("");
  }

  /* DOErangeother */
  const [textDoe, settextDoe] = useState("");

  /* DSE range */
  const [dseRange, setDseRange] = useState("");
  const [dseRangeError, setDseRangeError] = useState("");
  function handleChangeDseRange(selectedOption) {
    setDseRange(selectedOption.value);
    setDseRangeError("");
  }

  /* DSErangeother */
  const [textDse, settextDse] = useState("");

  /* NRI range */
  const [nriRange, setNriRange] = useState("");
  const [nriRangeError, setNriRangeError] = useState("");
  function handleChangeNriRange(selectedOption) {
    setNriRange(selectedOption.value);
    setNriRangeError("");
  }

  /* NRI rangeother */
  const [textNri, settextNri] = useState("");

  /* mmerange */
  const [mmerange, setmmerange] = useState("");
  const [mmerangeError, setmmerangeError] = useState("");
  function handleChangemmerange(selectedOption) {
    setmmerange(selectedOption.value);
    setmmerangeError("");
  }

  /* rvnrange */
  const [rvnrange, setRvnrange] = useState("");
  const [rvnrangeError, setRvnrangeError] = useState("");
  function handleChangervnrange(selectedOption) {
    setRvnrange(selectedOption.value);
    setRvnrangeError("");
  }

  /* rvn1range */
  const [rvn1range, setRvn1range] = useState("");
  const [rvn1rangeError, setRvn1rangeError] = useState("");
  function handleChangervn1range(selectedOption) {
    setRvn1range(selectedOption.value);
    setRvn1rangeError("");
  }

  /* bstcrange */
  const [bstCrange, setBstCrange] = useState("");
  function handleChangeBstCrange(selectedOption) {
    setBstCrange(selectedOption.value);
  }

  /* bstfrange */
  const [bstFrange, setBstFrange] = useState("");
  const [bstFrangeError, setBstFrangeError] = useState("");
  function handleChangeBstFrange(selectedOption) {
    setBstFrange(selectedOption.value);
    setBstFrangeError("");
  }

  const [success, setSuccess] = useState();
  const [createStartupdatahalfJear, { loadingStartupdatahalfJear }] =
    useMutation(CREATE_HALF_YEAR, {
      onCompleted: (providerData) => {
        setSuccess(true);
      },
    });
  const handleSubmit = (e) => {
    e.preventDefault();
    if (intrange === "") {
      setIntrangeError("Please select a valid entry.");
      document.getElementById("select-Int").scrollIntoView();
    } else if (vacrange === "") {
      setVacrangeError("Please select a valid entry.");
      document.getElementById("select-Vac").scrollIntoView();
    } else if (nhcrange === "") {
      setNhcrangeError("Please select a valid entry.");
      document.getElementById("select-Nhc").scrollIntoView();
    } else if (lnkRrange === "") {
      setLnkRrangeError("Please select a valid entry.");
      document.getElementById("select-Lnkr").scrollIntoView();
    } else if (lnkNrange === "") {
      setLnkNrangeError("Please select a valid entry.");
    } else if (lnkIrange === "") {
      setLnkIrangeError("Please select a valid entry.");
      document.getElementById("select-Lnki").scrollIntoView();
    } else if (ievRrange === "") {
      setIevRrange("Please select a valid entry.");
      document.getElementById("select-Ievr").scrollIntoView();
    } else if (ievNrange === "") {
      setIevNrange("Please select a valid entry.");
      document.getElementById("select-Ievn").scrollIntoView();
    } else if (ievIrange === "") {
      setIevIrange("Please select a valid entry.");
      document.getElementById("select-Ievi").scrollIntoView();
    } else if (ievCrange === "") {
      setIevCrange("Please select a valid entry.");
      document.getElementById("select-Ievc").scrollIntoView();
    } else if (ntwUrange === "") {
      setNtwUrange("Please select a valid entry.");
      document.getElementById("select-NtwU").scrollIntoView();
    } else if (conrange === "") {
      setConrange("Please select a valid entry.");
      document.getElementById("select-Con").scrollIntoView();
    } else if (stSrange === "") {
      setStSrange("Please select a valid entry.");
      document.getElementById("select-StS").scrollIntoView();
    } else if (mmerange === "") {
      setmmerange("Please select a valid entry.");
      document.getElementById("select-Mme").scrollIntoView();
    } else if (daf1range === "") {
      setDaf1rangeError("Please select a valid entry.");
      document.getElementById("select-Daf1").scrollIntoView();
    } else if (daf2range === "") {
      setDaf2rangeError("Please select a valid entry.");
      document.getElementById("select-Daf2").scrollIntoView();
    } else if (daf3range === "") {
      setDaf3rangeError("Please select a valid entry.");
      document.getElementById("select-Daf3").scrollIntoView();
    } else if (bed2range === "") {
      setBed2rangeError("Please select a valid entry.");
      document.getElementById("select-Bed2").scrollIntoView();
    } else if (bed1range === "") {
      setBed1rangeError("Please select a valid entry.");
      document.getElementById("select-Bed1").scrollIntoView();
    } else if (bed2range === "") {
      setBed2rangeError("Please select a valid entry.");
      document.getElementById("select-Bed2").scrollIntoView();
    } else if (rvnrange === "") {
      setRvnrangeError("Please select a valid entry.");
      document.getElementById("select-Rvn").scrollIntoView();
    } else if (rvn1range === "") {
      setRvn1rangeError("Please select a valid entry.");
      document.getElementById("select-Rvn1").scrollIntoView();
    } else if (bstFrange === "") {
      setBstFrangeError("Please select a valid entry.");
      document.getElementById("select-Bstf").scrollIntoView();
    } else if (wnfRange === "") {
      setWnfRangeError("Please select a valid entry.");
      document.getElementById("select-Wnf").scrollIntoView();
    } else if (doeRange === "") {
      setDoeRangeError("Please select a valid entry.");
      document.getElementById("select-Doe").scrollIntoView();
    } else if (dseRange === "") {
      setDseRangeError("Please select a valid entry.");
      document.getElementById("select-Dse").scrollIntoView();
    } else if (nriRange === "") {
      setNriRangeError("Please select a valid entry.");
      document.getElementById("select-Nri").scrollIntoView();
    } else if (bstFrange === "") {
      setBstFrangeError("Please select a valid entry.");
      document.getElementById("select-Bstf").scrollIntoView();
    } else {
      function testVariables(variables) {
        // Durchgehen Sie jeden Schlüssel in den Variablen
        for (let key in variables) {
          // Überprüfen Sie, ob der Schlüsselwert null ist
          if (variables[key] === null) {
            console.log(`Die Variable ${key} hat den Wert null.`);
          }
          // Überprüfen Sie, ob der Schlüsselwert undefined ist
          else if (variables[key] === undefined) {
            console.log(`Die Variable ${key} ist undefined.`);
          }
        }
      }

      // Prepare your variables
      let variables = {
        EMP: parseInt(emp),
        INT: intrange,
        VAC: vacrange,
        VAC_1: parseInt(vac1),
        NHC: nhcrange,
        BTW: parseInt(btw),
        CUS_B: parseInt(cusb),
        CUS_E: parseInt(cuse),
        CUS_N: parseInt(cusn),
        DAF_1: daf1range,
        DAF_2: daf2range,
        DAF_3: daf3range,
        BED1: bed1range,
        BED2: bed2range,
        LNK_R: lnkRrange,
        LNK_N: lnkNrange,
        LNK_I: lnkIrange,
        IEV_R: ievRrange,
        IEV_N: ievNrange,
        IEV_I: ievIrange,
        IEV_C: ievCrange,
        NTW_US: ntwUrange.map((r) => r.value),
        NTW_UT: textNtwUt,
        NTW_M: ntwM,
        CON: conrange,
        ST_S: stSrange.map((r) => r.value),
        FSCS: fscrange.map((r) => r.value),
        VC_3: vc3range,
        VC_5: vc5range,
        VC_6: vc6range ? vc6range : null,
        VC_8: vc8range,
        MME: mmerange,
        RVN: rvnrange,
        RVN_1: rvn1range,
        BST_C: bstCrange ? bstCrange : null,
        BST_F: bstFrange,
        WNF: wnfRange,
        WNFT: textWnf,
        DOE: doeRange,
        DOET: textDoe,
        DSE: dseRange,
        DSET: textDse,
        NRI: nriRange,
        NRIT: textNri,
        startupid: startupId,
      };

      // Rufen Sie dann die Funktion auf, bevor Sie `createStartupdatahalfJear` aufrufen
      testVariables(variables);

      createStartupdatahalfJear({
        variables: variables,
      });
    }
  };

  return (
    <div className="absolute left-0 right-0 flex flex-col items-center overflow-y-auto bottom-14 top-20">
      {!success && valid && done && (
        <>
          <h1 className="m-2 mt-10">Startup Dates half Year</h1>
          <p>
            <strong>
              All data is collected anonymously and cannot be tracked back to
              you.
            </strong>
          </p>
          <div className="flex flex-wrap">
            <div className="w-full">
              <form
                onSubmit={handleSubmit}
                className="w-full max-w-xl p-4 m-auto"
              >
                <h3>Basic Data of Startups</h3>
                <label className="ml-2 align-middle inline-block">
                  How many employees does your startup currently have?
                  <span className="required">*</span>
                </label>
                <input
                  required
                  className="w-full"
                  type="number"
                  placeholder="How many employees does your startup currently have?"
                  value={emp}
                  onChange={(e) => setName(e.target.value)}
                ></input>
                <label className="ml-2 align-middle inline-block">
                  Are you hiring or offering internships?
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-int"
                  onChange={handleChangeintrange}
                  options={intranges}
                  placeholder="yes or no"
                />
                {intrangeError !== "" && (
                  <p className="ml-2 -mt-3 text-red-400 ">{intrangeError}</p>
                )}
                <label className="ml-2 align-middle inline-block">
                  How many job vacancies are currently open in your startup?
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Vac"
                  onChange={handleChangevacrange}
                  options={vacranges}
                  placeholder="How many job vacancies are currently open in your startup?"
                />
                {vacrangeError !== "" && (
                  <p className="ml-2 -mt-3 text-red-400 ">{vacrangeError}</p>
                )}
                <label className="ml-2 align-middle inline-block">
                  How many of the vacant jobs are subject to social security
                  contributions?
                  <span className="required">*</span>
                </label>
                <input
                  required
                  className="w-full"
                  type="number"
                  placeholder="1-100"
                  value={vac1}
                  onChange={(e) => setVac1(e.target.value)}
                ></input>
                <label className="ml-2 align-middle inline-block">
                  How many employees were hired in your startup in the last six
                  months?
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Nhc"
                  onChange={handleChangenhcrange}
                  options={nhcranges}
                  placeholder="e.g. 0, 1-2, 3-4..."
                />
                {nhcrangeError !== "" && (
                  <p className="ml-2 -mt-3 text-red-400 ">{nhcrangeError}</p>
                )}
                <h3>Customer Score</h3>
                <label className="ml-2 align-middle inline-block">
                  How many customers did you have at the beginning of this
                  half-year? (0-100%)
                  <span className="required">*</span>
                </label>
                <input
                  required
                  className="w-full"
                  type="range"
                  min="0"
                  max="100"
                  placeholder="How many customers did you have at the beginning of this half-year?"
                  value={btw}
                  onChange={(e) => setBtw(e.target.value)}
                ></input>
                <p>{btw}%</p>

                <label className="ml-2 align-middle inline-block">
                  How many customers did you have at the beginning of this
                  half-year?
                  <span className="required">*</span>
                </label>
                <input
                  required
                  className="w-full"
                  type="number"
                  placeholder="How many customers did you have at the beginning of this half-year?"
                  value={cusb}
                  onChange={(e) => setCusb(e.target.value)}
                ></input>
                <label className="ml-2 align-middle inline-block">
                  How many customers did you have in total at the end of this
                  half-year?
                  <span className="required">*</span>
                </label>
                <input
                  required
                  className="w-full"
                  type="number"
                  placeholder="How many customers did you have in total at the end of this half-year?"
                  value={cuse}
                  onChange={(e) => setCuse(e.target.value)}
                ></input>
                <label className="ml-2 align-middle inline-block">
                  How many new customers did you acquire this half-year?
                  <span className="required">*</span>
                </label>
                <input
                  required
                  className="w-full"
                  type="number"
                  placeholder="How many new customers did you acquire this half-year?"
                  value={cusn}
                  onChange={(e) => setCusn(e.target.value)}
                ></input>
                <h3>Talent Score</h3>
                <label className="ml-2 align-middle inline-block">
                  The match is very good between the startup's demands and the
                  employees' personal skills.
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Daf1"
                  onChange={handleChangedaf1range}
                  options={daf1ranges}
                  placeholder="e.g. Strongly agree, Somewhat agree, Partially agree ..."
                />
                {daf1rangeError !== "" && (
                  <p className="ml-2 -mt-3 text-red-400 ">{daf1rangeError}</p>
                )}
                <label className="ml-2 align-middle inline-block">
                  The employees' abilities and training are a good fit with the
                  requirements of the startup's jobs.
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Daf2"
                  onChange={handleChangedaf2range}
                  options={daf2ranges}
                  placeholder="e.g. Strongly agree, Somewhat agree, Partially agree ..."
                />
                {daf2rangeError !== "" && (
                  <p className="ml-2 -mt-3 text-red-400 ">{daf2rangeError}</p>
                )}
                <label className="ml-2 align-middle inline-block">
                  The employees' personal abilities and education provide a good
                  match with the demands that the startup places on them.
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Daf3"
                  onChange={handleChangedaf3range}
                  options={daf3ranges}
                  placeholder="e.g. Strongly agree, Somewhat agree, Partially agree ..."
                />
                {daf3rangeError !== "" && (
                  <p className="ml-2 -mt-3 text-red-400 ">{daf3rangeError}</p>
                )}
                <label className="ml-2 align-middle inline-block">
                  Our talent pool is sufficient to handle the current workload.
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Bed1"
                  onChange={handleChangeBed1range}
                  options={bed1ranges}
                  placeholder="e.g. Strongly agree, Somewhat agree, Partially agree ..."
                />
                {bed1rangeError !== "" && (
                  <p className="ml-2 -mt-3 text-red-400 ">{bed1rangeError}</p>
                )}
                <label className="ml-2 align-middle inline-block">
                  My startup is able to attract suitable talent for upcoming
                  tasks in the future.
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Bed2"
                  onChange={handleChangeBed2range}
                  options={bed2ranges}
                  placeholder="e.g. Strongly agree, Somewhat agree, Partially agree ..."
                />
                {bed2rangeError !== "" && (
                  <p className="ml-2 -mt-3 text-red-400 ">{bed2rangeError}</p>
                )}
                {/*
                <label  className="ml-2 align-middle inline-block">
                How easy is it for your startup to attract new talent?
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Bed3"
                  onChange={handleChangeBed3range}
                  options={bed3ranges}
                  placeholder="e.g. Strongly agree, Somewhat agree, Partially agree ..."
                />
                {bed3rangeError !== "" && <p className="ml-2 -mt-3 text-red-400 ">{bed3rangeError}</p>}
                <label  className="ml-2 align-middle inline-block">
                How easy is it to fill open positions?
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Bed4"
                  onChange={handleChangeBed4range}
                  options={bed4ranges}
                  placeholder="e.g. Strongly agree, Somewhat agree, Partially agree ..."
                />
                {bed4rangeError !== "" && <p className="ml-2 -mt-3 text-red-400 ">{bed4rangeError}</p>}
                <label  className="ml-2 align-middle inline-block">
                How do you rate the pool of talents in the Frankfurt Rhein Main Region
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Bed5"
                  onChange={handleChangeBed5range}
                  options={bed5ranges}
                  placeholder="e.g. Strongly agree, Somewhat agree, Partially agree ..."
                />
                
                {bed5rangeError !== "" && (
                  <p className="ml-2 -mt-3 text-red-400 ">{bed5rangeError}</p>
                )}
                */}
                <h3>Networking Score</h3>
                <label className="ml-2 align-middle inline-block">
                  I am well connected with other startups on a regional level.
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Lnkr"
                  onChange={handleChangelnkRrange}
                  options={lnkRranges}
                  placeholder="e.g. Strongly agree, Somewhat agree, Partially agree ..."
                />
                {lnkRrangeError !== "" && (
                  <p className="ml-2 -mt-3 text-red-400 ">{lnkRrangeError}</p>
                )}
                <label className="ml-2 align-middle inline-block">
                  I am well linked with other startups on a national level.
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Lnkn"
                  onChange={handleChangelnkNrange}
                  options={lnkNranges}
                  placeholder="e.g. Strongly agree, Somewhat agree, Partially agree ..."
                />
                {lnkNrangeError !== "" && (
                  <p className="ml-2 -mt-3 text-red-400 ">{lnkNrangeError}</p>
                )}
                <label className="ml-2 align-middle inline-block">
                  I am well connected with other startups on a international
                  level.
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Lnki"
                  onChange={handleChangelnkIrange}
                  options={lnkIranges}
                  placeholder="e.g. Strongly agree, Somewhat agree, Partially agree ..."
                />
                {lnkIrangeError !== "" && (
                  <p className="ml-2 -mt-3 text-red-400 ">{lnkIrangeError}</p>
                )}
                <label className="ml-2 align-middle inline-block">
                  How often do you attend regional startup/investor/networking
                  events?
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Ievr"
                  onChange={handleChangeievRrange}
                  options={ievRranges}
                  placeholder="e.g. never, > once or twice a month, once or twice a month..."
                />
                {ievRrangeError !== "" && (
                  <p className="ml-2 -mt-3 text-red-400 ">{ievRrangeError}</p>
                )}
                <label className="ml-2 align-middle inline-block">
                  How often do you attend national startup/investor/networking
                  events?
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Ievn"
                  onChange={handleChangeievNrange}
                  options={ievNranges}
                  placeholder="e.g. never, > once or twice a month, once or twice a month..."
                />
                {ievNrangeError !== "" && (
                  <p className="ml-2 -mt-3 text-red-400 ">{ievNrangeError}</p>
                )}
                <label className="ml-2 align-middle inline-block">
                  How often do you attend international
                  startup/investor/networking events?
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Ievi"
                  onChange={handleChangeievIrange}
                  options={ievIranges}
                  placeholder="e.g. never, > once or twice a month, once or twice a month..."
                />
                {ievIrangeError !== "" && (
                  <p className="ml-2 -mt-3 text-red-400 ">{ievIrangeError}</p>
                )}
                <label className="ml-2 align-middle inline-block">
                  How often is your COMPANY represented at events
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Ievc"
                  onChange={handleChangeievCrange}
                  options={ievCranges}
                  placeholder="e.g. never, > once or twice a month, once or twice a month..."
                />
                {ievCrangeError !== "" && (
                  <p className="ml-2 -mt-3 text-red-400 ">{ievCrangeError}</p>
                )}
                <label className="ml-2 align-middle inline-block">
                  What networking channels do you use for your startup?
                  <span className="required">*</span>
                </label>
                <p className="ml-2 text-xs">Multiple Select</p>
                <CustomMultiselectForm
                  id="select-NtwU"
                  onChange={handleChangentwUrange}
                  options={ntwUranges}
                  value={ntwUrange}
                  placeholder="e.g. digital channels (e.g., LinkedIn, Xing), Meetups, Conferences ..."
                />

                {ntwUrange.some((option) => option.value === "5") && (
                  <>
                    <label className="ml-2 align-middle inline-block">
                      Please specify other networking channels
                      <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      id="text-NtwU"
                      value={textNtwUt}
                      className="w-full"
                      onChange={(e) => setTextNtwU(e.target.value)}
                      placeholder="Please specify other networking channels"
                    />
                  </>
                )}
                {ntwUrangeError !== "" && (
                  <p className="ml-2 -mt-3 text-red-400 ">{ntwUrangeError}</p>
                )}
                <label className="ml-2 align-middle inline-block">
                  What support is missing from your network? Please provide your
                  suggestions<span className="required">*</span>
                </label>
                <input
                  required
                  className="w-full"
                  type="text"
                  placeholder="What support is missing from your network? Please provide your suggestions"
                  value={ntwM}
                  onChange={(e) => setntwM(e.target.value)}
                ></input>
                <label className="ml-2 align-middle inline-block">
                  How ist the quality of existing network
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Con"
                  onChange={handleChangeconrange}
                  options={conranges}
                  placeholder="Please select"
                />
                {conrangeError !== "" && (
                  <p className="ml-2 -mt-3 text-red-400 ">{conrangeError}</p>
                )}
                <label className="ml-2 align-middle inline-block">
                  I feel well connected in the VC and investor scene.
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-vc8"
                  onChange={handleChangevc8range}
                  options={vc8ranges}
                  placeholder="e.g. Strongly agree, Somewhat agree, Partially agree ..."
                />
                <label className="ml-2 align-middle inline-block">
                  Which networking activities do you want to strengthen in the
                  future?
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-wnf"
                  onChange={handleChangeWnfRange}
                  options={wnfranges}
                  placeholder="e.g. Strongly agree, Somewhat agree, Partially agree ..."
                />

                {wnfRangeError !== "" && (
                  <p className="ml-2 -mt-3 text-red-400 ">{wnfRangeError}</p>
                )}
                {wnfRange === "5" && (
                  <div>
                    <label className="ml-2 align-middle inline-block">
                      Which ones?
                      <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      className="w-full"
                      placeholder="Describe here..."
                      value={textWnf}
                      onChange={(e) => settextWnf(e.target.value)}
                    />
                  </div>
                )}
                <label className="ml-2 align-middle inline-block">
                  Do you organize events?
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-doe"
                  onChange={handleChangeDoeRange}
                  options={doeranges}
                  placeholder="e.g. Strongly agree, Somewhat agree, Partially agree ..."
                />
                {doeRangeError !== "" && (
                  <p className="ml-2 -mt-3 text-red-400 ">{doeRangeError}</p>
                )}
                {doeRange === "2" && (
                  <div>
                    <label className="ml-2 align-middle inline-block">
                      Which ones?
                      <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      className="w-full"
                      placeholder="Describe here..."
                      value={textDoe}
                      onChange={(e) => settextDoe(e.target.value)}
                    />
                  </div>
                )}

                <label className="ml-2 align-middle inline-block">
                  Do you act as a sponsor for events?
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-dse"
                  onChange={handleChangeDseRange}
                  options={dseranges}
                  placeholder="e.g. Strongly agree, Somewhat agree, Partially agree ..."
                />
                {dseRangeError !== "" && (
                  <p className="ml-2 -mt-3 text-red-400 ">{dseRangeError}</p>
                )}
                {dseRange === "2" && (
                  <div>
                    <label className="ml-2 align-middle inline-block">
                      Which ones?
                      <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      className="w-full"
                      placeholder="Describe here..."
                      value={textDse}
                      onChange={(e) => settextDse(e.target.value)}
                    />
                  </div>
                )}
                <div>
                  <label className="ml-2 align-middle inline-block">
                    Is the company actively engaged in national, regional,
                    international initiatives?
                    <span className="required">*</span>
                  </label>
                  <CustomSelect
                    id="select-nri"
                    onChange={handleChangeNriRange}
                    options={nriranges}
                    placeholder="e.g. Strongly agree, Somewhat agree, Partially agree ..."
                  />
                  {nriRangeError !== "" && (
                    <p className="ml-2 -mt-3 text-red-400 ">{nriRangeError}</p>
                  )}
                  {nriRange === "2" && (
                    <div>
                      <label className="ml-2 align-middle inline-block">
                        Which ones?
                        <span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        className="w-full"
                        placeholder="Describe here..."
                        value={textNri}
                        onChange={(e) => settextNri(e.target.value)}
                      />
                    </div>
                  )}
                </div>

                <h3>Investment Score</h3>
                {/*<label className="ml-2 align-middle inline-block">
                  What was the last funding round of your startup?
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Stf"
                  onChange={handleChangestFrange}
                  options={stFranges}
                  placeholder="e.g. Seed Capital, Angel Investor Funding..."
                />
                {stFrangeError !== "" && (
                  <p className="ml-2 -mt-3 text-red-400 ">{stFrangeError}</p>
                )}*/}
                <label className="ml-2 align-middle inline-block">
                  What stage is your startup currently in?
                  <span className="required">*</span>
                </label>
                <p className="ml-2 text-xs">Multiple Select</p>
                <CustomMultiselectForm
                  id="select-stS"
                  onChange={handleChangestSrange}
                  options={stSranges}
                  value={stSrange}
                  placeholder="e.g. Own savings, Cashflow, Family & Friends..."
                />
                {stSrangeError !== "" && (
                  <p className="ml-2 -mt-3 text-red-400 ">{stSrangeError}</p>
                )}
                <label className="ml-2 align-middle inline-block">
                  What are the overall funding sources for your startup?
                  <span className="required">*</span>
                </label>
                <p className="ml-2 text-xs">Multiple Select</p>
                <CustomMultiselectForm
                  id="select-fsc"
                  onChange={handleChangefscrange}
                  options={fscranges}
                  value={fscrange}
                  placeholder="e.g. Own savings, Cashflow, Family & Friends..."
                />
                {fscrangeError !== "" && (
                  <p className="ml-2 -mt-3 text-red-400 ">{fscrangeError}</p>
                )}
                <label className="ml-2 align-middle inline-block">
                  Which regions do most of your investors come from? (all
                  funding rounds)
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Vc3"
                  onChange={handleChangevc3range}
                  options={vc3ranges}
                  placeholder="e.g. regional, national, international..."
                />
                {vc3rangeError !== "" && (
                  <p className="ml-2 -mt-3 text-red-400 ">{vc3rangeError}</p>
                )}
                <label className="ml-2 align-middle inline-block">
                  When is the next investment round planned?
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-vc5"
                  onChange={handleChangevc5range}
                  options={vc5ranges}
                  placeholder="e.g. no investment round planned to date, > 2 years..."
                />
                {vc5rangeError !== "" && (
                  <p className="ml-2 -mt-3 text-red-400 ">{vc5rangeError}</p>
                )}
                <label className="ml-2 align-middle inline-block">
                  What is the planed investment volume for the next funding
                  round?
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-vc6"
                  onChange={handleChangevc6range}
                  options={vc6ranges}
                  placeholder="e.g. No revenue, 1 EUR to < 150.000 EUR..."
                />
                <label className="ml-2 align-middle inline-block">
                  Are you interested in investor match-making events?
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Mme"
                  onChange={handleChangemmerange}
                  options={mmeranges}
                  placeholder="e.g. Yes, No..."
                />
                {mmerangeError !== "" && (
                  <p className="ml-2 -mt-3 text-red-400 ">{mmerangeError}</p>
                )}
                <h3>Business Score</h3>
                <label className="ml-2 align-middle inline-block">
                  In the last year, how much revenue did you generate with your
                  startup?
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Rvn"
                  onChange={handleChangervnrange}
                  options={rvnranges}
                  placeholder="e.g. No revenue, 1 EUR to < 150.000 EUR..."
                />
                {rvnrangeError !== "" && (
                  <p className="ml-2 -mt-3 text-red-400 ">{rvnrangeError}</p>
                )}
                <label className="ml-2 align-middle inline-block">
                  What is the expected revenue in the upcoming year?
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Rvn1"
                  onChange={handleChangervn1range}
                  options={rvn1ranges}
                  placeholder="e.g. No revenue, 1 EUR to < 150.000 EUR..."
                />
                {rvn1rangeError !== "" && (
                  <p className="ml-2 -mt-3 text-red-400 ">{rvn1rangeError}</p>
                )}
                <label className="ml-2 align-middle inline-block">
                  How do you assess the current business situation?
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Bstc"
                  onChange={handleChangeBstCrange}
                  options={bstCranges}
                  placeholder="e.g. Optimistic, Neutral ..."
                />

                <label className="ml-2 align-middle inline-block">
                  How do you assess the business situation in the next 6 months?
                  <span className="required">*</span>
                </label>
                <CustomSelect
                  id="select-Bstf"
                  onChange={handleChangeBstFrange}
                  options={bstFranges}
                  placeholder="e.g. Optimistic, Neutral ..."
                />
                {bstFrangeError !== "" && (
                  <p className="ml-2 -mt-3 text-red-400 ">{bstFrangeError}</p>
                )}

                <div className="flex mt-4 mb-6 ml-2 text-left items-left">
                  <input required id="privacy" type="checkbox"></input>
                  <label
                    htmlFor="privacy"
                    className="ml-2 align-middle inline-block"
                  >
                    I agree to the{" "}
                    <a href="https://station-frankfurt.de/datenschutzerklaerung/">
                      privacy policy.
                    </a>
                    <span className="required">*</span>
                  </label>
                </div>
                <button
                  id="submit"
                  type="submit"
                  className="w-full mb-4 tertiary link-bold"
                  disabled={loadingStartupdatahalfJear}
                >
                  Submit form
                </button>
              </form>
            </div>
          </div>
        </>
      )}
      {success && done && valid && (
        <div className="items-center mx-auto mt-8 text-center">
          <h2>
            We have received the registration of your Startup Dates half Year.
          </h2>
          <Link to="/" className="items-center w-full">
            <li className="float-none w-56 mx-auto mt-8 list-none topbar-link-primary">
              Back to the map
            </li>
          </Link>
        </div>
      )}
      {done && !valid && (
        <div className="items-center mx-auto mt-8 text-center">
          <h2>There was an error with your token.</h2>
          <p className="mt-4 text-copy-main-regular">
            Please verify that your link is valid and not expired.
          </p>
          <Link to="/" className="items-center w-full">
            <li className="float-none w-56 mx-auto mt-8 list-none topbar-link-primary">
              Back to map
            </li>
          </Link>
        </div>
      )}
    </div>
  );
}

export default StartupdatahalfJear;
